import { useLocalization } from 'localization'
import { ResponseErrorType } from 'types/custom'

export function useGetErrorMessage() {
	const { t } = useLocalization()

	return ({ response, defaultKey }: { response: ResponseErrorType['response']; defaultKey: string }) => {
		const key = `errors.${response.data?.errorCode}`
		const translation = t(key)

		return key === translation ? t(defaultKey) : translation
	}
}

export default {
	analyzeResults: 'analyzeResults',
	analyzeStatus: 'analyzeStatus',
	clients: 'clients',
	cpas: 'cpas',
	creditPacks: 'creditPacks',
	current: 'current',
	featureAccess: 'featureAccess',
	jurisdictions: 'jurisdictions',
	jurisdictionBySlug: 'jurisdictionBySlug',
	jurisdictionProperties: 'jurisdictionProperties',
	integrationById: 'integrationById',
	integrations: 'integrations',
	integrationStatistic: 'integrationStatistic',
	marketPrices: 'marketPrices',
	onboarding: 'onboarding',
	organizationById: 'organizationById',
	organizationMembers: 'organizationMembers',
	plans: 'plans',
	recalculations: 'recalculations',
	receiverInvites: 'receiverInvites',
	reportBySlug: 'reportBySlug',
	reports: 'reports',
	senderInvites: 'senderInvites',
	stripeDashboardLink: 'stripeDashboardLink',
	supportedBlockchains: 'supportedBlockchains',
	transactionById: 'transactionById',
	transactions: 'transactions',
	transactionStatistic: 'transactionStatistic',
	tutorials: 'tutorials',
	userById: 'userById',
	vezgoSecret: 'vezgoSecret',
	vezgoToken: 'vezgoToken',
	walletById: 'walletById',
	wallets: 'wallets',
	wealthicaUserCredentials: 'wealthicaUserCredentials',
	wealthicaNewTransactions: 'wealthicaNewTransactions',
}
